import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _get from "lodash/get";
var _excluded = ["intl", "list", "secondaryList", "isMobile", "onRequestClose", "onClickLinkCallback"];
import React, { useContext, useEffect } from 'react';
import { ThemeContext } from 'styled-components';
import { injectIntl } from 'react-intl';
import withSizes from 'react-sizes';
import { Modal, modalPropTypes } from '~modal';
import { isSizes } from '~layout';
import Navigation from '../Navigation';
import headerPropTypes from '../../prop-types/headerPropTypes';
import headerTheme from '../../styles/headerTheme';

var MenuModal = function MenuModal(_ref) {
  var intl = _ref.intl,
      list = _ref.list,
      secondaryList = _ref.secondaryList,
      isMobile = _ref.isMobile,
      onRequestClose = _ref.onRequestClose,
      _onClickLinkCallback = _ref.onClickLinkCallback,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var theme = useContext(ThemeContext);

  var modalOffsetTop = _get(theme, 'header.menuModal.offsetTop', headerTheme.header.menuModal.offsetTop);

  var modalEntryTransitionY = _get(theme, 'header.menuModal.entryTransitionY', headerTheme.header.menuModal.entryTransitionY);

  useEffect(function () {
    if (!isMobile) {
      onRequestClose();
    }
  }, [isMobile]);
  return /*#__PURE__*/React.createElement(Modal, Object.assign({
    offsetTop: modalOffsetTop,
    entryTransitionY: modalEntryTransitionY,
    title: intl.formatMessage({
      id: 'header.mobile.menu.title'
    }),
    footerActions: secondaryList,
    size: "default",
    showCloseButton: true,
    isContentCover: true
  }, props), /*#__PURE__*/React.createElement(Navigation, {
    list: list,
    isMobile: isMobile,
    isListVertical: true,
    onClickLinkCallback: function onClickLinkCallback() {
      _onClickLinkCallback();

      setTimeout(function () {
        onRequestClose();
      }, 100);
    }
  }));
};

var mapSizesToProps = function mapSizesToProps(_ref2, _ref3) {
  var width = _ref2.width;
  var theme = _ref3.theme;
  return {
    isMobile: isSizes.mdView({
      width: width
    }, {
      theme: theme
    })
  };
};

MenuModal.defaultProps = {
  list: null,
  secondaryList: null,
  isMobile: false,
  onRequestClose: null,
  onClickLinkCallback: function onClickLinkCallback() {}
};
export default injectIntl(withSizes(mapSizesToProps)(MenuModal));